import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BadgeCheck: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="badge check icon">
      {/* <title>badge check icon</title> */}
      <g id="badge-check">
        <path
          id="Vector"
          d="M8.0001 1.6001C8.9201 1.6001 9.7201 2.1176 10.1226 2.8776C10.9451 2.6026 11.8526 2.8241 12.5251 3.4746C13.1751 4.1251 13.3526 5.0551 13.1226 5.8776C13.8826 6.2801 14.4001 7.0801 14.4001 8.0001C14.4001 8.9201 13.8826 9.7201 13.1226 10.1226C13.3751 10.9451 13.1751 11.8526 12.5251 12.5251C11.8526 13.1751 10.9451 13.3526 10.1226 13.1226C9.7201 13.8826 8.9201 14.4001 8.0001 14.4001C7.0801 14.4001 6.2801 13.8826 5.8776 13.1226C5.0551 13.3751 4.1251 13.1751 3.4746 12.5251C2.8241 11.8526 2.6251 10.9451 2.8776 10.1226C2.1176 9.7201 1.6001 8.9201 1.6001 8.0001C1.6001 7.0801 2.1176 6.2801 2.8776 5.8776C2.6026 5.0551 2.8241 4.1251 3.4746 3.4746C4.1251 2.8241 5.0551 2.6251 5.8776 2.8776C6.2801 2.1176 7.0801 1.6001 8.0001 1.6001ZM10.4026 7.2026C10.6576 6.9901 10.6576 6.6101 10.4026 6.3751C10.1901 6.1426 9.8101 6.1426 9.5751 6.3751L7.2001 8.7526L6.2026 7.7751C5.9901 7.5426 5.6101 7.5426 5.3751 7.7751C5.1426 8.0101 5.1426 8.3901 5.3751 8.6026L6.7751 10.0026C7.0101 10.2576 7.3901 10.2576 7.6026 10.0026L10.4026 7.2026Z"
          fill={props.fill || "currentColor"}
        />
      </g>
    </svg>
  );
};

export default BadgeCheck;
